import { __assign, __rest } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { itemHeadingCSS } from './styles';
var HeadingItem = function (_a) {
    var children = _a.children, testId = _a.testId, id = _a.id, _b = _a.cssFn, cssFn = _b === void 0 ? function (currentStyles) { return currentStyles; } : _b, rest = __rest(_a, ["children", "testId", "id", "cssFn"]);
    return (jsx("div", __assign({ css: cssFn(itemHeadingCSS), "data-testid": testId, id: id }, rest), children));
};
export default HeadingItem;
//# sourceMappingURL=heading-item.js.map